<div class="child-list">
  <ng-container *ngIf="loaded$ | async; else loading">
    <ng-container *ngIf="children$ | async as children">
      <div class="child-count text-white bg-secondary border border-grey rounded d-flex justify-content-between p-3">
        <div class="child-list-title d-flex text-white fw-bold">
          <div class="heading-text">{{ 'kids.page.child.added' | translate }}</div>
          <span class="heading-text length-num ms-3">{{ children.data?.length }}</span>
        </div>
        <div class="button-wrapper" [class.w-upgrade]="children.free?.length > 0">
          <!-- Upgrade Kids -->
          <div
            class="btn text-white btn-upgrade-kids my-auto p-0 d-flex align-items-center justify-content-center cursor-pointer border-white"
            (click)="upgradeChildren()"
            *ngIf="children.free?.length > 0"
          >
            <span class="material-icons text-black arrow_upward me-2 fw-bold">arrow_upward</span>
            <span class="text-white upgrade-kid fw-bold">{{ 'guardian.button.upgrade' | translate }}</span>
          </div>
          <!--Add kids-->
          <div
            class="btn btn-primary text-white btn-add-kids align-items-center justify-content-center d-flex cursor-pointer mr-lg-3"
            [routerLink]="['/register/newchildren']"
            *ngIf="children.data?.length < children.limit"
          >
            <span class="material-icons-outlined me-2"> add_circle </span>
            <span class="mr-auto add-kid fw-bold child-add-button">{{ 'child.list.add.button.text' | translate }}</span>
          </div>
        </div>
      </div>
      <div class="mt-20" *ngIf="children.data?.length">
        <div>
          <owl-carousel-o [options]="customOptions">
            <ng-template *ngFor="let child of children.data" carouselSlide [width]="301">
              <div class="mb-1">
                <fgb-child-panel [child]="child"></fgb-child-panel>
              </div>
            </ng-template>
          </owl-carousel-o>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #loading>
    <div class="loading-container mt-3">
      <fgbcl-loading></fgbcl-loading>
    </div>
  </ng-template>
</div>
